import React, { useState } from "react";
import axios from "axios";
import "../styles/InternAdmin.css";

const InternAdmin = () => {

  const [interns, setInterns] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState("");

  const fetchCollegeData = async (college) => {
    try {
      const res = await axios.get(`/api/intern/${college}`);
      setInterns(res.data);
      setSelectedCollege(college.toUpperCase());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="admin-container">

      <h1 className="admin-title">Internship Registrations</h1>

      <div className="college-buttons">

        <button onClick={() => fetchCollegeData("c1")}>College C1</button>
        <button onClick={() => fetchCollegeData("c2")}>College C2</button>
        <button onClick={() => fetchCollegeData("c3")}>College C3</button>
        <button onClick={() => fetchCollegeData("c4")}>College C4</button>
        <button onClick={() => fetchCollegeData("c5")}>College C5</button>
        <button onClick={() => fetchCollegeData("others")}>Others</button>
      </div>

      {selectedCollege && (
        <div className="table-container">

          <h2>{selectedCollege} Interns</h2>

          <table className="intern-table">

            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Branch</th>
                <th>Course</th>
                <th>Amount</th>
                <th>Order ID</th>
              </tr>
            </thead>

            <tbody>
              {interns.map((intern) => (
                <tr key={intern.id}>
                  <td>{intern.id}</td>
                  <td>{intern.internName}</td>
                  <td>{intern.email}</td>
                  <td>{intern.mobile}</td>
                  <td>{intern.branch}</td>
                  <td>{intern.course}</td>
                  <td>₹{intern.amount}</td>
                  <td>{intern.orderId}</td>
                </tr>
              ))}
            </tbody>

          </table>

        </div>
      )}

    </div>
  );
};

export default InternAdmin;